import { marked } from "marked"
import createDOMPurify from "dompurify"
import { el } from "./dom.js"

marked.use({
  gfm: true,
  breaks: true,
})

let purify

function getPurify() {
  if (purify) return purify
  const root = typeof window !== "undefined" ? window : globalThis
  purify = createDOMPurify(root)
  return purify
}

export { getPurify }

/** Allowed tags/attrs for RAG narrative HTML (no scripts/styles/forms). */
const SANITIZE = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["style", "script", "iframe", "object", "embed", "form", "input", "button"],
  FORBID_ATTR: ["style", "onerror", "onclick", "onload"],
  ALLOW_DATA_ATTR: false,
}

/**
 * Convert markdown to sanitized HTML string.
 * @param {string} markdown
 * @returns {string}
 */
export function markdownToHtml(markdown) {
  const src = typeof markdown === "string" ? markdown : ""
  if (!src.trim()) return ""
  const dirty = marked.parse(src, { async: false })
  return getPurify().sanitize(String(dirty), SANITIZE)
}

/**
 * Render markdown into a content container element.
 * @param {string} markdown
 * @param {{ className?: string }} [opts]
 * @returns {HTMLElement|null}
 */
export function renderMarkdownHtml(markdown, opts = {}) {
  const html = markdownToHtml(markdown)
  if (!html) return null
  const node = el("div", { className: opts.className || "md-block content" })
  node.innerHTML = html
  return node
}
